export default "__VITE_ASSET__XCqDRFK5__"